import SpinRecord from "slotworks/model/gameplay/records/spin-record";

export default class RespinRecord extends SpinRecord {
    public id = "RespinRecord";
}
